import * as React from 'react';
import { Spinner as Spinner$2, Blobs, Blob } from './MegaForm.styles.js';

// all credit for the animation goes to apester https://codepen.io/team/apester/pen/pEEVRO
var Spinner = function Spinner() {
  return /*#__PURE__*/React.createElement(Spinner$2, {
    className: "leshen-mega-form-spinner"
  }, /*#__PURE__*/React.createElement(Blobs, null, /*#__PURE__*/React.createElement(Blob, {
    left: true
  }), /*#__PURE__*/React.createElement(Blob, null)), /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "goo"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: "10"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "blur",
    mode: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7",
    result: "goo"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "goo",
    "in": "SourceGraphic",
    result: "mix"
  })))));
};
var Spinner$1 = Spinner;

export { Spinner$1 as default };
//# sourceMappingURL=Spinner.js.map
